/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
/* NPM Imports Start */
import React from 'react';
import PropsTypes from 'prop-types';
import ScrollView from 'devextreme-react/scroll-view';
/* NPM Imports End */

/* Project Imports Start */

/* Project Imports End */

/* CCS & Image imports Start */
import './single-card.scss';
/* CCS & Image imports End */

const SingleCard = ({ title, description, children }) => (
  <ScrollView className={'with-footer single-card'}>
    <div className={'dx-card content'}>
      <div className={'header'}>
        <div className={'title'}>{title}</div>
        <div className={'description'}>{description}</div>
      </div>
      {children}
    </div>
  </ScrollView>
);

export default SingleCard;

SingleCard.displayName = 'SingleCard';

/* PropsTypes Validation Start*/
SingleCard.propTypes = {
  title: PropsTypes.any,
  description: PropsTypes.any,
  children: PropsTypes.any,
};
/* PropsTypes Validation End*/

/* DefaultProps */
SingleCard.defaultProps = {};
/* DefaultProps */
